import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "src/app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { LearnsetsListComponent } from "src/app/shared/learnsets-list/learnsets-list.component";
import { CreateExamComponent } from "./create-exam.component";
import { LearnsetSelectionList } from "./learnset-selection-list/learnset-selection-list.component";
import { TablerIconComponent } from "angular-tabler-icons";

@NgModule({
  declarations: [
    CreateExamComponent,
    LearnsetSelectionList
  ],
  imports: [
    CommonModule,
    ControlsModule,
    SharedModule,
    TranslateModule,
    LearnsetsListComponent,
    TablerIconComponent
  ],
  exports: [
    CreateExamComponent,
    LearnsetSelectionList
  ]
})
export class CreateExamModule { }